import React, { useState, useEffect, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import Loader from "../Loader/Loader";

import moment from "moment";
import { WalletMA } from "boa-sdk-ts";
import { addressFormat, amountFormat } from "../../utils/WalletUtils";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import { AmountBOA } from "../common/amountBOA";

const PendingTransaction = (props) => {
  // These are states of current component
  const { t, selectedAccount } = props;
  const [transaction, setTransaction] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [mounted, setMounted] = useState(true);

  const transactionList = useMemo(() => {
    return transaction;
  }, [transaction]);

  useEffect(() => {
    return () => {
      setMounted(false);
    };
  }, []);
  useEffect(() => {
    if (selectedAccount && selectedAccount.address) {
      getPendingTransaction(selectedAccount.address);
    }
  }, [selectedAccount]);
  useEffect(() => {
    if (
      selectedAccount &&
      selectedAccount.address &&
      props.getSocketConnection.SocketConnection
    ) {
      getPendingTransaction(selectedAccount.address);
    }
  }, [props.getSocketConnection.SocketConnection]);

  // This method use to get pending transaction and get param as a public key of selected account
  const getPendingTransaction = async (publickey) => {
    const { client } = WalletMA.instance();
    setLoader(true);
    const res = await client.getTransactionsPending(publickey);
    if (mounted) {
      setLoader(false);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        if (res.data !== undefined) {
          setTransaction(res.data);
        } else {
          setError(t("sorry_no_data"));
        }
      }
    }
  };

  const cancelClickHandler = async (tx_hash) => {
    props.history.push({
      pathname: "overview/pendingTransactionDetails",
      state: { tx_hash: tx_hash },
    });
  };

  const TimeZoneFormat = (time) => {
    if (props.getTimeZone && props.getTimeZone.TimeZone === "Local Time") {
      return moment(time * 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment.utc(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  };

  return (
    <>
      {/* Pending Transaction list screen  */}
      <div className="TableBg cardBg mt-30">
        <div className="ContHeader pendingTable">
          <h3>{t("Pending_Transactions")}</h3>
        </div>
        <div className="table-responsive pending-table">
          <table className="table panelTable">
            <thead className="tableHead">
              <tr>
                <th className="TimeZoneFormat">{t("Submission_time")}</th>
                <th>{t("Block_delay")}</th>
                <th className="amount_align">{t("Amount")}</th>
                <th>{t("Target")}</th>
                <th>{t("Fee")}</th>
                <th>{t("Action")}</th>
              </tr>
            </thead>
            {loader ? (
              <Loader />
            ) : transactionList.length > 0 ? (
              <tbody>
                {transactionList.map((info) => (
                  <tr
                    key={info.tx_hash}
                    onClick={() => cancelClickHandler(info.tx_hash)}
                  >
                    <td className="TimeZoneFormat">
                      <span>{TimeZoneFormat(info.submission_time)}</span>
                    </td>
                    <td>{info.block_delay}</td>
                    <td className="amount_align">
                      <AmountBOA amount={info.amount} />
                    </td>
                    <td>
                      <div className="purpleText tooltip1">
                        {addressFormat(info.address)}
                        <div className="tooltiptext1">
                          <p>{info.address}</p>
                        </div>
                      </div>
                    </td>
                    <td>{amountFormat(info.fee)} BOA</td>
                    <td>
                      <div className="action-btns">
                        {<button>{t("Cancel")}</button>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr className="noData">
                  <td className="inner">
                    <h3 className="text-center mb-3">{error}</h3>
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(PendingTransaction))
);
